import AssetTypeIcon from "components/elements/Chip/AssetTypeIcon";
import AutocadIconSvg from "components/icons/autocad-icon.svg";
import RevitIconSvg from "components/icons/revit-icon.svg";

export default function AutodeskFileIcon(p: { extension: string | null }) {
  switch (p.extension) {
    case "rvt":
      return <RevitIconSvg />;
    case "dwg":
    case "dxf":
      return <AutocadIconSvg />;
    default:
      return <AssetTypeIcon ext={p.extension} />;
  }
}
